import { render } from "./HeroCarousel.vue?vue&type=template&id=5044e0bd&scoped=true"
import script from "./HeroCarousel.vue?vue&type=script&lang=js"
export * from "./HeroCarousel.vue?vue&type=script&lang=js"

import "./HeroCarousel.vue?vue&type=style&index=0&id=5044e0bd&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5044e0bd"]])

export default __exports__